import * as React from "react";

import { EmailEditorOpenedFrom } from "@simplyk/common";

import { AmplitudeEvents } from "@/constants/amplitude";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";

export const useEmailPreview = ({
  emailContent,
}: {
  emailContent?: { id: string; openFrom?: EmailEditorOpenedFrom | null };
}) => {
  const [previewOpened, setPreviewOpened] = React.useState(false);
  const { logAmplitudeEvent } = useAmplitude();

  const openPreview = React.useCallback(() => {
    logAmplitudeEvent(AmplitudeEvents.EmailPreviewOpened, { openFrom: emailContent?.openFrom });
    setPreviewOpened(true);
  }, [emailContent?.openFrom, logAmplitudeEvent]);

  const closePreview = React.useCallback(() => setPreviewOpened(false), []);

  return { previewOpened, openPreview, closePreview };
};
